/* eslint-disable */ 
import React, { useEffect, useState } from "react"; 
import "./index.scss"; 
import api from "@/utils/api"; 
import http from "@/utils/http"; 
import homeImg from "@/assets/images/home/home_3.png";

const Home = () => { 
  let initFullName = ""; 
  try { 
    const userStr = localStorage.getItem("user"); 
    if (userStr) { 
      const userObj = JSON.parse(userStr); 
      initFullName = `${userObj?.firstName || ""} ${userObj?.lastName || ""}`.trim(); 
    } 
  } catch (e) {} 
  
  const [fullName, setFullName] = useState(initFullName || "Ryan Liu"); 
  
  const getFullName = async () => { 
    try { 
      const response = await http.get(api.getNameStr); 
      if (response?.code === "1" && response.data) { 
        setFullName(response.data); 
      } 
    } catch (e) {} 
  }; 
  
  useEffect(() => { 
    getFullName(); 
  }, []); 
  
  return ( 
    <div className="home-page"> 
      <div className="home-card"> 
        <div className="home-left"> 
          <div className="welcome-text">WELCOME!</div> 
          <div className="hi-block"> 
            <div className="hi-title">Hi ! {fullName}</div> 
            <p className="hi-desc"> 
  Welcome to the system. May this be the starting point for a productive and smooth workday. Wishing you success in everything you do today.
            </p> 
          </div> 
          {/* <div className="home-actions"> 
            <button className="btn-primary">Download App</button> 
            <button className="btn-link"> 
              Learn More 
              <span className="arrow">→</span> 
            </button> 
          </div> 
          <div className="home-stats"> 
            <div className="stat-item"> 
              <div className="stat-number">280K+</div> 
              <div className="stat-label">Users use the app</div> 
            </div> 
            <div className="stat-divider" /> 
            <div className="stat-item"> 
              <div className="stat-number">127K+</div> 
              <div className="stat-label">Users use the System</div> 
            </div> 
          </div>  */}
        </div> 
        <div className="home-right"> 
          <img 
            src={homeImg} 
            alt="Dashboard overview" 
            className="home-illustration" 
          /> 
        </div> 
      </div> 
    </div> 
  ); 
}; 

export default Home;